// extracted by mini-css-extract-plugin
export default {"overlay":"CTAOverlay_overlay__SLgy5"};